<template>

</template>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';

const router = useRouter();
const route = useRoute();

const pre_page = route.query.pre_page || null;

onMounted(async () => {
	// 먼저 사용자 정보를 초기화하여 토큰 제거 (무한 루프 방지)
	globaljs.clearUserInfo();
	
	// Authorization 헤더 제거
	if (window.axios && window.axios.defaults) {
		delete window.axios.defaults.headers.common['Authorization'];
	}

	try {
		const response = await axios.post(`${SERVER_URL}/api/app/auth/logout`, {}, {
			validateStatus: function (status) {
				// 401 에러도 정상으로 처리하여 무한 루프 방지
				return status >= 200 && status < 500;
			}
		});
console.debug('logout.onMounted().response: ', response);

		if (!pre_page && response.status !== 401) {
			toast.fire({
				icon: "success",
				title: "로그아웃 완료!",
			});
		}

	} catch (error) {
		// 401 에러는 무시 (이미 로그아웃된 상태일 수 있음)
		if (error?.response?.status !== 401) {
			console.error(error?.response?.data);
			toast.fire({
				icon: "error",
				title: error?.response?.data?.result?.message || "로그아웃 중 오류가 발생했습니다."
			});
		}
	} finally {
		// 로그인 페이지로 이동
		setTimeout(() => {
			router.push("/login").catch(() => {
				// 라우터 에러 무시하고 강제 이동
				window.location.href = "/login";
			});
		}, 100);
	}
});
</script>